import React from 'react';
import '../../components/css/popupstyle.css';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import $ from 'jquery';
import { userService } from '../../_services/user.service';

class CommissionPayoutAllBinJD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            btnLoader: false,
            error: '',
            columnData: []
        }
        this.reportData = this.reportData.bind(this);
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                paramsName: JSON.parse(localStorage.getItem('user')).paramsname,
                userdata: JSON.parse(localStorage.getItem('user')),
                MonthList: []
            };
        }
        catch (error) { }
    }
    componentDidMount() {
        this.GetCommission_Separate(this.state.userdata.wholesaler, this.state.userdata.wholesaler_Id, '');
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    GetCommission_Separate(whname, wholesaler_Id, mname) {

        this.setState({ loader: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ whname, wholesaler_Id, mname })
        };
        return fetch(`/api/ws/GetWholesalerCommission_Separated_CustomCommission`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        this.setState({ MonthList: apidata[0]["monthList"], loader: false, error: '' });
                    } else {
                        this.setState({ loader: false, error: 'Data not found' });
                    }
                }
                catch (error) {
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    reportData(e) {
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            let month_year = $("#commissionSelect").val();
            let paramsName = this.state.paramsName;
            let wh_id = this.state.userdata.wholesaler_Id;
            let unique_ObjectId = this.state.userdata.unique_ObjectId;
            let End_Point = "/report/payout_report_jd_Custom_allBins";
            window.open(
                Origin_Location + End_Point + '?&name=' + paramsName + '&wh_id=' + wh_id + '&csvfor=ds&m=' + month_year + '&processor=0&ObjectId=' + unique_ObjectId,
                '_blank'
            );
            e.preventDefault();
        }
        catch (error) { }
    }
    handleFocus = () => {
        $('#commissionSelect').prop('size', 10);
    }
    handleBlur = () => {
        $('#commissionSelect').prop('size', 1);
    }
    render() {
        const { loader, error, btnLoader } = this.state;
        return (

            <div className='popup mfp-zoom-in report-section commission-edit popup-right-radius'>
                <div className='popup_inner'>

                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    {
                        loader ? <div className="theme-loader commissionLoader"></div> : null
                    }
                    {
                        this.state.MonthList.length ?
                            <div id="dashboard_header" className="big_dash_header">
                                <div className="dashboard-icons">

                                    <DashboardHeaderIcons />

                                </div>
                                <div id="dashboard_header_inner">
                                    <div id="dashboard-back-button"></div>
                                    <div id="dashboard_header_select">
                                        <form>
                                            <div className="selectSection payout">
                                                <label>Select Month, Year</label>
                                                <span className="down-arrow"></span>
                                                <select className="form-Control" id="commissionSelect" onChange={this.handleOnChange} value={this.state.value} >
                                                    {
                                                        this.state.MonthList != null ?
                                                            this.state.MonthList.map((obj, index) => {
                                                                return <option value={obj.monthYearname}>{obj.monthYearname.replace(',', ', ')}</option>
                                                            }) : null
                                                    }
                                                </select>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="pop-btn ungap">
                                                {
                                                    btnLoader ? <div className="theme-loader commissionLoader btnLoader"></div> : null
                                                }
                                                <button className={btnLoader ? "btn btn-theme-color animated-btn" : "btn btn-theme-color"} onClick={this.reportData}>Download</button>
                                                <button className="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </div> :
                            <div>
                                {
                                    loader ?
                                        <div className="please-wait data-not-found"><h3>Please wait...</h3></div> :
                                        <span className="data-not-found">{error}</span>
                                }
                            </div>
                    }
                </div>
            </div>
        );
    }
}
export default CommissionPayoutAllBinJD;